
import React from 'react';
import { getServiceName, newUserEmailBody } from '../../utils/consts';
import { NineCellLoading } from 'react-loadingg';
import Cookies from 'universal-cookie';
import siteLogin from '../../services/siteLogin';
import loginService from '../../services/login';
import signUpUser from '../../services/signupUser';
import sendMail from '../../services/sendMainEmail';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

// Firebase
import { initializeApp } from 'firebase/app';
import { getAnalytics, setUserProperties } from "firebase/analytics";

// Styles 
import './style.css';
import './bootstrap.min.css';
import './owl.carousel.css';
import './owl.theme.css';
import './owl.transitions.css';
import './animate.css';
import './preloader.css';
import translateString from '../../utils/Locales';
import resetPasswordSito from '../../services/resetPasswordSito';
import Utils from '../../utils/utils';

var analytics = null;
let t = translateString;
let qs = require('querystring');

export default class MainLogin extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            login: true, 
            signup: false, 
            username: '', 
            password: '', 
            ragioneSociale: '', 
            fullName: '',
            email: '', 
            r_password: '', 
            alertRagione: false,
            alertName: false,
            alertEmail: false,
            alertPassword: false,
            alertUser: false,
            errorMessage: '',
        };
    }

    checkEmail(mail) {
        return (/^[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(mail));
    }

    async componentDidMount() {
        document.title = getServiceName() + ' - Login';
        Utils.setAnalyticsPage('Main Login')

        let params = qs.parse(window.location.hash);
        if (params['#/main/login?signup'] !== undefined) {
            this.setState({ login: false, signup: true });
        }

        const cookies = new Cookies();
        if (cookies.get('approvedCookies', { path: '/' }) === 'all') {
            /* const app = initializeApp(firebaseConfig);
            analytics = getAnalytics(app); */
        }
    }

    async handleLogin(event) {

        event.preventDefault();

        if (this.state.username.trim().length === 0 || this.state.password.trim().length === 0) {
            this.setState({ username: '', password: '', alertUser: true, alertPassword: true });

            setTimeout(() => {
                this.setState({ alertUser: false, alertPassword: false });
            }, 2000);
        } else {
            this.setState({ isLoading: true });

            // Perfom login
            const res = await siteLogin(this.state.username, this.state.password);
            
            if (res && res.user != null) {
                
                if(res.user.active == 0) {
                    // Successful login -> go to account page 
                    const cookies = new Cookies();
                    cookies.set('site_username', this.state.username, { path: '/' });
                    cookies.set('db', res.user.db_name, { path: '/' });
                    cookies.set('site_token', res.token, { path: '/' });

                    window.location.href = '/#/main/account?endSubscription=true';
                } else {
                    const cookies = new Cookies();
                    cookies.set('db', res.user.db_name, { path: '/' });
                    const resp = await loginService(this.state.username, this.state.password, res.user.db_name);
                    if (resp != null) {
                        window.location.href = res.user.db_name + '#/login?username=' + this.state.username + '&token=' + resp.token;
                    } else {
                        // Fallback on account page 
                        cookies.set('site_username', this.state.username, { path: '/' });
                        cookies.set('site_token', res.token, { path: '/' });
                        window.location.href = '/#/main/account';
                    }
                    //window.location.href = Constants.defaultProtocol + res.user.db_name
                }
            } else {
                this.setState({ error: true, isLoading: false });
                
                setTimeout(() => {
                    this.setState({ error: false });
                }, 2000);
            }
        }    
    }

    testString(str) {
        var contains = true;

        if (str.includes('à') || str.includes('á')) contains = false;
        if (str.includes('è') || str.includes('é')) contains = false;
        if (str.includes('ì') || str.includes('í')) contains = false;
        if (str.includes('ò') || str.includes('ó')) contains = false;
        if (str.includes('ù') || str.includes('ú')) contains = false;

        return contains;
    }

    async handleSignup(event) {

        event.preventDefault();
        this.setState({ isLoading: true });

        // Check inserted data
        if (this.state.username !== '' && this.state.ragioneSociale.trim() !== '' && this.state.password !== '' && this.state.fullName !== '' &&  this.state.email !== '' && this.checkEmail(this.state.email) && this.state.password === this.state.r_password) {

            if (!this.testString(this.state.username) || !this.testString(this.state.ragioneSociale.trim()) || !this.testString(this.state.password) || !this.testString(this.state.fullName)) {
                alert("Non sono consentiti caratteri accentati in questi campi.");
                this.setState({ isLoading: false });
                return;
            }

            // Perform signup to main users
            const res = await signUpUser(this.state.username, this.state.password, this.state.ragioneSociale, this.state.fullName, this.state.email);
            if (res != null) {
                if (res.result == 'KO') {
                    if (res.description.includes('email')) {
                        this.setState({ isLoading: false, error: true, alertEmail: true, errorMessage: t('email_presa')});
                        setTimeout(() => {
                            this.setState({ error: false });
                        }, 5000);
                    } else if (res.description.includes('username')) {
                        this.setState({ isLoading: false, error: true, alertUser: true, errorMessage: t('username_preso')});
                        setTimeout(() => {
                            this.setState({ error: false });
                        }, 5000);
                    }
                } else {
                    if (analytics != null) setUserProperties(analytics, { site_user_logged: true, main_user: false });
                    
                    await sendMail(this.state.email, this.state.fullName, t('benvenuto_2'), newUserEmailBody(this.state.fullName));
                    await this.handleLogin(event);
                }
            } else {
                this.setState({ isLoading: false, error: true, errorMessage: t('errore_imprevisto')});
                setTimeout(() => {
                    this.setState({ error: false });
                }, 5000);
            }
        } else {
            if (this.state.password !== this.state.r_password || this.state.password.trim().length === 0 || this.state.r_password.trim().length === 0) {
                this.setState({ isLoading: false, alertPassword: true, errorMessage: t('verifica_passwords')});
                setTimeout(() => {
                    this.setState({ alertPassword: false });
                }, 5000);
            } 
            if (this.state.ragioneSociale.trim().length === 0) {
                this.setState({ isLoading: false, alertRagione: true, errorMessage: ""});
                setTimeout(() => {
                    this.setState({ alertRagione: false });
                }, 5000);
            }
            if (this.state.username.trim().length === 0 ) {
                this.setState({ isLoading: false, alertUser: true, errorMessage: ""});
                setTimeout(() => {
                    this.setState({ alertUser: false });
                }, 5000);
            }
            if (this.state.fullName.trim().length === 0 ) {
                this.setState({ isLoading: false, alertName: true, errorMessage: ""});
                setTimeout(() => {
                    this.setState({ alertName: false });
                }, 5000);
            }
            if (this.state.email.trim().length === 0 || !this.checkEmail(this.state.email)) {
                this.setState({ isLoading: false, alertEmail: true, errorMessage: ""});
                setTimeout(() => {
                    this.setState({ alertEmail: false });
                }, 5000);
            }
        }
    } 

    async handleReset() {
        if (this.state.username.trim() === '') {
            alert(t('errore_res'));
            return;
        }

        await resetPasswordSito(this.state.username, t('language_string'));
        alert(t('reset_fatto_a'));
    }

    render () {

        if (this.state.isLoading) return <NineCellLoading />

        return (
            <div className='mainBody' style={{width: '100%', height: '100%'}}>
                
                <header id='home' style={{height: '100%'}}>
                <nav className="navbar navbar-expand-lg fixed-top">
                    <div className="container">
                        <img alt="" className='navbar-brand' style={{width: 'auto', height: 80, marginBottom: 10, cursor: 'pointer' }} onClick={() => window.location.href='/#/main/home'} src={require('../../images/icon.png')}/>                        
                        <div className="collapse navbar-collapse" id="navbarNav" style={{ marginTop: -20 }}>
                            <ul className="nav navbar-nav ml-auto">
                                <li>
                                    <div className="lang-btn" style={{ marginLeft: 30 }} onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'it') }}><img src={ require('../../images/it.png') } style={{ width: 20, height: 'auto' }}/></div>
                                </li>
                                <li>
                                    <div className="lang-btn" onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'en') }}><img src={ require('../../images/en.png') } style={{ width: 20, height: 'auto' }}/></div>
                                </li>
                            </ul>

                        </div>
                    </div>
                </nav>

                <div className="new-banner" style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, flex: 1 }}>
                    <div className="new-container" style={{ backgroundColor: '#7DA4A0' }}>
                        <div className="row">
                            <div className="col-md-8 offset-md-2" style={{ alignContent: 'center', justifyItems: 'center', justifyContent: 'center'}}>
                                <div className="caption">
                                        <div className="loginContainer">
                                            { this.state.login && (
                                                <div style={{ paddingBottom: '20px' }}>
                                                    <h3 style={{marginTop: 20}}>{t('accedi')}</h3>
                                                    <p style={{ width: '80%', marginLeft: '10%' }}>{t('accedi_account')} <a style={{ cursor: 'pointer', color: '#041130', fontWeight: 'bold' }} onClick={() => this.setState({ signup: true, login: false })}>{t('crealo')}</a></p>
                                                    { this.state.error && (
                                                        <div className='loginError'>
                                                            <p style={{ fontSize: '1rem', color: 'red' }}>{t('credenziali_non_valide')}</p>
                                                        </div>
                                                    )}
                                                    <input 
                                                        name='username' 
                                                        style={{border: this.state.alertUser ? "1px solid red" : ""}}
                                                        type='text' 
                                                        placeholder='Username' 
                                                        className="inputCustom" 
                                                        value={this.state.username} 
                                                        onChange={(e) => this.setState({ username: e.target.value })} 
                                                        onKeyDown={(e) => e.key === "Enter" && this.handleLogin(e)}
                                                    />
                                                    <br/>
                                                    <input 
                                                        name='password' 
                                                        type='password' 
                                                        placeholder='Password' 
                                                        className="inputCustom" 
                                                        value={this.state.password} 
                                                        style={{marginTop: 7, border: this.state.alertPassword ? "1px solid red" : ""}} 
                                                        onChange={(e) => this.setState({ password: e.target.value })} 
                                                        onKeyDown={(e) => e.key === "Enter" && this.handleLogin(e)}
                                                    />
                                                    <br/>
                                                    <div className='loginView' style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                                                        <div type='submit' className='btn btn-primary' style={{marginTop: '20px'}} onClick={(e) => this.handleLogin(e)}>{t('accedi').toUpperCase()}</div>
                                                        <div style={{ cursor: 'pointer', color: '#4C73F7', marginTop: '20px', fontSize: 12 }} onClick={() => this.handleReset()}>{t('password_dimenticata')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            { this.state.signup && (
                                                <div>
                                                    <h3 style={{marginTop: 20}}>{t('registrati')}</h3>
                                                    <p>{t('crea_account')}</p>
                                                    <p style={{ fontSize: 12, marginTop: -20 }}>{t('hai_account')} <a style={{ cursor: 'pointer', color: '#041130', fontWeight: 'bold', fontSize: 14 }} onClick={() => this.setState({ signup: false, login: true })}>{t('accedi')}</a></p>
                                                    { this.state.error && (
                                                        <div className='loginError'>
                                                            <p style={{ fontSize: '1rem', color: 'red' }}>{this.state.errorMessage}</p>
                                                        </div>
                                                    )}
                                                    <input 
                                                        style={{ marginTop: 7, border: this.state.alertRagione ? "1px solid red" : ""}} 
                                                        name='ragioneSociale' 
                                                        type='text' 
                                                        placeholder={t('ragione_sociale')} 
                                                        className="inputCustom" value={this.state.ragioneSociale} 
                                                        onChange={(e) => this.setState({ ragioneSociale: e.target.value })} 
                                                    />
                                                    <br/>
                                                    <input 
                                                        style={{ marginTop: 7, border: this.state.alertName ? "1px solid red" : ""}} 
                                                        name='full_name' type='text' placeholder={t('full_name')} 
                                                        className="inputCustom" value={this.state.fullName} 
                                                        onChange={(e) => this.setState({ fullName: e.target.value })} 
                                                    />
                                                    <br/>
                                                    <input 
                                                        style={{ marginTop: 20, border: this.state.alertUser ? "1px solid red" : ""}}
                                                        name='username'
                                                        type='text' 
                                                        placeholder='Username' 
                                                        className="inputCustom" 
                                                        value={this.state.username} 
                                                        onChange={(e) => this.setState({ username: e.target.value })} 
                                                    />
                                                    <br/>
                                                    <input 
                                                        style={{ marginTop: 7, border: this.state.alertEmail ? "1px solid red" : ""}} 
                                                        name='email' 
                                                        type='mail' 
                                                        placeholder='Email' 
                                                        className="inputCustom" 
                                                        value={this.state.email} 
                                                        onChange={(e)=> this.setState({ email: e.target.value })} 
                                                    />
                                                    <br/>
                                                    <input 
                                                        style={{ marginTop: 7, border: this.state.alertPassword ? "1px solid red" : ""}} 
                                                        name='password' 
                                                        type='password' 
                                                        placeholder='Password' 
                                                        className="inputCustom" 
                                                        value={this.state.password} 
                                                        onChange={(e) => this.setState({ password: e.target.value })} 
                                                    />
                                                    <br/>
                                                    <input 
                                                        style={{ marginTop: 7, border: this.state.alertPassword ? "1px solid red" : ""}} 
                                                        name='r_password' 
                                                        type='password' 
                                                        placeholder={t('conferma_pwd')} 
                                                        className="inputCustom" value={this.state.r_password} 
                                                        onChange={(e) => this.setState({ r_password: e.target.value })} 
                                                    />
                                                    <br/>
                                                    <div type='submit' className='btn btn-primary' style={{marginTop: '20px'}} onClick={(e) => this.handleSignup(e)}>{t('registrati').toUpperCase()}</div>
                                                </div>
                                            )}
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </header>
            </div>
        );
    }
}
